import React, { useMemo } from "react";
import styles from "./Banner.module.scss";
import classNames from "classnames/bind";
import Button from "../../components/ui/Button/Button";
import { useLanguageStore } from "../../stores/Language/useLanguageStore";
import defaultMenuData from "../../data/menuItems.json";

const cx = classNames.bind(styles);

const Banner = ({ showBtn, imgSrc, className, ...propsBtn }) => {
  const { currentLanguage, translations } = useLanguageStore();

  const currentTranslations = useMemo(() => {
    return translations[currentLanguage] || defaultMenuData.content;
  }, [translations, currentLanguage]);

  const classes = cx("banner", {
    [className]: className,
  });

  return (
    <div className={classes}>
      <img src={imgSrc} alt="Banner" className={cx("banner__image")} />
      {showBtn && (
        <div className={cx("banner__content")}>
          <Button
            content={currentTranslations?.Button?.Shop_now}
            primary={true}
            {...propsBtn}
            className={cx("btn_banner")}
          />
        </div>
      )}
    </div>
  );
};

export default Banner;
